import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { formatPrice } from "@/lib/api";
import { ArrowUpRight } from "lucide-react";

export default function ProductCard({ product, index = 0 }) {
  return (
    <motion.div
      data-testid={`product-card-${product.id}`}
      initial={{ opacity: 0, y: 50 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-60px" }}
      transition={{ duration: 0.8, ease: [0.76, 0, 0.24, 1], delay: (index % 3) * 0.1 }}
      className="group"
    >
      <Link to={`/product/${product.id}`} data-testid={`product-link-${product.id}`}>
        <div className="relative overflow-hidden border border-border bg-card aspect-[4/5]">
          <img
            src={product.image}
            alt={product.name}
            loading="lazy"
            className="w-full h-full object-cover transition-transform duration-[900ms] ease-[cubic-bezier(0.76,0,0.24,1)] group-hover:scale-105"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-background/70 via-transparent to-transparent opacity-60" />
          <div className="absolute top-4 left-4 text-[10px] tracking-[0.3em] uppercase text-foreground/90 bg-background/40 backdrop-blur-sm px-3 py-1 border border-border">
            {product.category}
          </div>
          <div className="absolute bottom-4 right-4 h-11 w-11 flex items-center justify-center border border-primary bg-background/30 backdrop-blur-sm text-primary translate-y-2 opacity-0 transition-[transform,opacity] duration-500 group-hover:translate-y-0 group-hover:opacity-100">
            <ArrowUpRight size={18} />
          </div>
        </div>
        <div className="mt-5 flex items-start justify-between gap-4">
          <div>
            <h3 className="font-serif text-xl font-light">{product.name}</h3>
            <p className="text-xs text-muted-foreground mt-1">{product.short_desc}</p>
          </div>
          <span className="text-primary text-sm whitespace-nowrap mt-1">{formatPrice(product.price)}</span>
        </div>
      </Link>
    </motion.div>
  );
}
